import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import { getPosterUrl } from '@/mocks/imageUrls';

const reviews = [
  {
    name: '小王',
    avatar: '王',
    rating: 5,
    content: '奇优影院真的太好用了！更新速度超快，新上映的电影基本第二天就能看到。画质也很清晰，完全不卡顿，强烈推荐！',
    date: '2026-07-28',
  },
  {
    name: '电影发烧友',
    avatar: '影',
    rating: 5,
    content: '作为一个资深影迷，奇优影院是我用过资源最全的平台。无论是热门大片还是小众文艺片都能找到，而且全是高清资源。',
    date: '2026-07-25',
  },
  {
    name: '追剧达人',
    avatar: '剧',
    rating: 5,
    content: '追剧党的福音！每天都有更新提醒，热门剧集更新超及时。播放流畅不卡顿，画质也很棒，已经推荐给身边所有朋友了。',
    date: '2026-07-22',
  },
  {
    name: '小李同学',
    avatar: '李',
    rating: 4,
    content: '用了半年多了，整体体验非常不错。资源丰富，更新快，界面也很清爽。希望以后能增加更多海外剧资源。',
    date: '2026-07-18',
  },
  {
    name: '周末观影人',
    avatar: '观',
    rating: 5,
    content: '奇优影院是我每周末的必备娱乐。分类清晰，找片方便，播放器功能也很完善。免费而且无广告，真的良心平台！',
    date: '2026-07-15',
  },
  {
    name: '电影评论家',
    avatar: '评',
    rating: 5,
    content: '从专业角度看，奇优影院的片源质量和更新速度在同类平台中都是顶尖的。涵盖题材广泛，满足不同观众的审美需求。',
    date: '2026-07-10',
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotField = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotField && honeypotField.value.trim() !== '') {
      setFormStatus('success');
      setFormMessage('提交成功，感谢您的留言！');
      form.reset();
      return;
    }

    setIsSubmitting(true);
    setFormStatus('idle');
    setFormMessage('');

    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9mvq5cit35ii3jdlmr0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      const code = parsed?.code;
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (response.ok && code === 'OK') {
        setFormStatus('success');
        setFormMessage('提交成功，感谢您的留言！我们会尽快回复。');
        form.reset();
      } else {
        if (typeof serverMsg === 'string' && serverMsg.includes('spam')) {
          setFormStatus('error');
          setFormMessage('提交失败，请稍后再试。');
        } else {
          setFormStatus('error');
          setFormMessage(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后再试。');
        }
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请检查网络后重试。');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-20 min-h-screen">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-5xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />

            <section className="mb-16">
              <div className="text-center mb-12">
                <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">关于奇优影院</h1>
                <p className="text-foreground-500 text-base max-w-2xl mx-auto leading-relaxed">
                  致力于打造中国领先的免费高清在线观影平台
                </p>
              </div>

              <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
                <div className="flex-1">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-800 mb-4">品牌介绍</h2>
                  <p className="text-foreground-500 text-sm leading-relaxed mb-4">
                    奇优影院成立于2020年，是一家专注于提供<strong>最新电影</strong>和<strong>最新电视剧</strong>在线观看服务的平台。
                    我们汇集了海量的影视资源，涵盖电影、电视剧、综艺、动漫等多种类型，致力于为广大用户提供<strong>高清免费在线观看</strong>的优质体验。
                  </p>
                  <p className="text-foreground-500 text-sm leading-relaxed mb-4">
                    奇优影院拥有专业的内容运营团队，<strong>新片上映同步更新快</strong>，热门剧集每日更新，
                    确保用户能够第一时间观看到最新的影视内容。我们采用先进的视频传输技术，<strong>不缓冲流畅播放</strong>，
                    让追剧成为一种纯粹的享受。
                  </p>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    作为<strong>追剧首选平台</strong>，奇优影院始终坚持用户至上的理念，不断优化产品体验，丰富内容资源。
                    我们的愿景是让每一个人都能轻松享受到高品质的在线观影服务。
                  </p>
                </div>
                <div className="flex-shrink-0 w-full lg:w-[400px]">
                  <img
                    src={getPosterUrl('about-img')}
                    alt="奇优影院团队"
                    title="奇优影院 - 专业影视内容运营团队"
                    className="w-full rounded-xl object-cover"
                    style={{ height: '280px' }}
                  />
                </div>
              </div>
            </section>

            <section className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-800 mb-8 text-center">用户口碑</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {reviews.map((review, index) => (
                  <div
                    key={index}
                    className="p-5 rounded-xl bg-background-800/50 border border-background-700/30 hover:border-primary-500/20 transition-all"
                  >
                    <div className="flex items-center gap-3 mb-3">
                      <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/20 text-primary-400 font-bold text-sm">
                        {review.avatar}
                      </span>
                      <div>
                        <p className="text-foreground-800 font-medium text-sm">{review.name}</p>
                        <p className="text-foreground-500 text-xs">{review.date}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-1 mb-2">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-xs text-accent-400"></i>
                      ))}
                    </div>
                    <p className="text-foreground-500 text-sm leading-relaxed">{review.content}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-16">
              <div className="max-w-2xl mx-auto">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-800 mb-8 text-center">联系我们</h2>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
                  <div className="p-5 rounded-xl bg-background-800/50 border border-background-700/30 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/10">
                      <i className="ri-mail-line text-xl text-primary-400"></i>
                    </div>
                    <p className="text-foreground-500 text-xs mb-1">电子邮箱</p>
                    <p className="text-foreground-800 text-sm font-medium">contact@qiyoucinema.com</p>
                  </div>
                  <div className="p-5 rounded-xl bg-background-800/50 border border-background-700/30 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/10">
                      <i className="ri-phone-line text-xl text-primary-400"></i>
                    </div>
                    <p className="text-foreground-500 text-xs mb-1">客服电话</p>
                    <p className="text-foreground-800 text-sm font-medium">400-888-8888</p>
                  </div>
                  <div className="p-5 rounded-xl bg-background-800/50 border border-background-700/30 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/10">
                      <i className="ri-map-pin-line text-xl text-primary-400"></i>
                    </div>
                    <p className="text-foreground-500 text-xs mb-1">公司地址</p>
                    <p className="text-foreground-800 text-sm font-medium">北京市朝阳区光华路9号</p>
                  </div>
                </div>

                <div className="p-6 md:p-8 rounded-xl bg-background-800/50 border border-background-700/30">
                  <h3 className="text-foreground-800 font-bold text-lg mb-6">在线留言</h3>
                  <form onSubmit={handleSubmit} className="space-y-5" data-readdy-form>

                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      readOnly
                      aria-hidden
                      className="sp-field-hidden"
                    />

                    <div>
                      <label htmlFor="contact-name" className="block text-foreground-600 text-sm mb-2">姓名</label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        placeholder="请输入您的姓名"
                        className="w-full px-4 py-3 bg-background-900 border border-background-700 rounded-lg text-sm text-foreground-800 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50 transition"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-foreground-600 text-sm mb-2">邮箱</label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        placeholder="请输入您的邮箱"
                        className="w-full px-4 py-3 bg-background-900 border border-background-700 rounded-lg text-sm text-foreground-800 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50 transition"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-message" className="block text-foreground-600 text-sm mb-2">留言内容</label>
                      <textarea
                        id="contact-message"
                        name="message"
                        required
                        rows={4}
                        maxLength={500}
                        placeholder="请输入您的留言内容（500字以内）"
                        className="w-full px-4 py-3 bg-background-900 border border-background-700 rounded-lg text-sm text-foreground-800 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50 transition resize-none"
                      ></textarea>
                    </div>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full py-3 bg-primary-500 text-background-950 font-bold text-sm rounded-full hover:bg-primary-400 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                    >
                      {isSubmitting ? '提交中...' : '提交留言'}
                    </button>

                    {formStatus === 'success' && (
                      <div className="p-3 bg-accent-500/10 border border-accent-500/30 rounded-lg text-accent-400 text-sm text-center">
                        {formMessage}
                      </div>
                    )}
                    {formStatus === 'error' && (
                      <div className="p-3 bg-red-500/10 border border-red-500/30 rounded-lg text-red-400 text-sm text-center">
                        {formMessage}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}